import { createActionCreator, createReducer } from 'deox';
import { ScenesDownloadingProgress } from 'types/ScenesDownloadingProgress';
import { AppState } from 'types/AppState';
import { Scene } from 'types/Scene';
import { omit } from 'ramda';

const defaultState: ScenesDownloadingProgress = {};

export type SetScenesDownloadingProgressAction = (progress: number, sceneId: string) => void;

export const setScenesDownloadingProgress = createActionCreator(
  'DOWNLOADING_PROGRESS/SET',
  resolve => (progress: number, sceneId: string) => resolve({ progress, sceneId })
);

export const deleteSceneDownloadingProgress = createActionCreator(
  'DOWNLOADING_PROGRESS/DELETE',
  resolve => (sceneId: string) => resolve(sceneId)
);

export const scenesDownloadingProgress = createReducer(defaultState, handle => [
  handle(setScenesDownloadingProgress, (store, { payload }) => ({
    ...store,
    [payload.sceneId]: payload.progress
  })),
  handle(deleteSceneDownloadingProgress, (store, { payload }) => omit([payload], store))
]);

export const getDownloadingProgressOfScene = (id: Scene['id']) => (state: AppState) =>
  state.scenesDownloadingProgress[id];

export const isScenesCreated = (state: AppState) =>
  Boolean(
    Object.values(state.scenesDownloadingProgress).filter(item => item < 100 && item !== 0)
      .length ||
      Object.values(state.scenesCreationProgress).filter(item => item < 100 && item !== 0).length
  );
